import React, { FC, ReactNode } from 'react'
import { Box, Typography } from '@mui/material'
import { withProps } from '@utils/hoc'
import colors from '@const/colors.json'
import { Price } from '@components/ui'
import { useCard } from '@utils/context/cardContext'
import { withStyles } from 'tss-react/mui'

const PriceWrapper = withProps(({ children }) => <span>{children}</span>, { className: 'text-xl font-bold whitespace-nowrap' })

export type SummaryContainerProps = {
  variant: 'outlined' | 'contained'
  primaryColor: string
  secondaryColor: string
}

const SummaryContainerHOC = Container => {
  // eslint-disable-next-line react/display-name
  return ({ variant, primaryColor, secondaryColor, children }) => {
    const Wrapper = withStyles(Container, {
      root: {
        backgroundColor: variant === 'outlined' ? secondaryColor : primaryColor,
        color: variant === 'outlined' ? primaryColor : secondaryColor,
        borderRadius: '4px'
      }
    })

    return <Wrapper className="p-[15px]">{children}</Wrapper>
  }
}

export const SummaryText = SummaryContainerHOC(Typography)

export const SummaryBox = SummaryContainerHOC(Box)

const SummaryTitle = withStyles(withProps(Typography, { component: 'h2' }), {
  root: {
    fontSize: '20px',
    color: colors.white
  }
})

type Line = {
  label: string
  price: number
}

type SummaryProps = {
  title: string
  lines: Array<Line>
  additional?: ReactNode
}

const Summary: FC<SummaryProps> = ({ title, lines, additional }) => {
  const { totalIncludingTaxesWithShipping } = useCard()

  return (
    <div className="flex flex-col items-stretch justify-between rounded-lg bg-super-ya-blue5 px-[20px] py-[30px] sm:gap-y-[40px] mobile:space-y-[20px]">
      <SummaryTitle>{title}</SummaryTitle>
      <ul>
        {lines.map(line => (
          <li key={line.label}>
            <Typography variant="subtitle2" className="flex justify-between text-super-ya-white sm:gap-x-[20px] mobile:space-y-[20px]">
              <span>{line.label}</span>
              {line.price > -1 ? <Price price={line.price} /> : 'A définir'}
            </Typography>
          </li>
        ))}
      </ul>
      <Typography variant="subtitle2" className="flex justify-between font-bold text-super-ya-white">
        <span>Total panier</span>
        <Price price={totalIncludingTaxesWithShipping} Wrapper={PriceWrapper} />
      </Typography>
      <div className="flex flex-col items-stretch space-y-[20px]">{additional}</div>
    </div>
  )
}

export default Summary
